import type { RepeatingSectionColumn } from '../types/docGen.types';

/** Add Column 으로 추가한 컬럼인지 (템플릿 기본 컬럼은 삭제 불가) */
export function isCustomRepeatingColumn(col: RepeatingSectionColumn): boolean {
  if (col.isCustom === true) return true;
  if (col.isCustom === false) return false;
  return /^custom_\d+$/i.test(String(col.varKey || '').trim());
}

export function nextCustomColumnKey(columns: RepeatingSectionColumn[]): string {
  let max = 0;
  for (const col of columns) {
    const m = String(col.varKey || '').match(/^custom_(\d+)$/i);
    if (m) max = Math.max(max, Number.parseInt(m[1], 10));
  }
  return `custom_${max + 1}`;
}

export function createCustomRepeatingColumn(columns: RepeatingSectionColumn[]): RepeatingSectionColumn {
  const varKey = nextCustomColumnKey(columns);
  return {
    varKey,
    header: 'New Column',
    varLabel: varKey,
    isCustom: true,
  };
}
